import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CanonicalService {

  constructor(@Inject(DOCUMENT) private dom: Document) {}

  /**
   * Creates or updates the canonical link element in the document head.
   * @param url The absolute canonical URL for the current route
   */
  setCanonicalURL(path: string): void {
    const fullUrl = environment.websiteUrl + '/' + path;
    let link: HTMLLinkElement | null = this.dom.querySelector("link[rel='canonical']");

    if (link) {
      link.setAttribute('href', fullUrl);
    } else {
      link = this.dom.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', fullUrl);
      this.dom.head.appendChild(link);
    }
  }
}